<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("user_guest.search") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <select
                  v-model="positionSelected"
                  class="form-control"
                  style="width: 100%;"
                  >
                  <option
                      v-for="position in positionList"
                      v-bind:key="position.id"
                      class="form-control"
                      v-bind:value="position.id"
                  >{{ $t(position.name) }}</option>
                  </select>
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4"></div>
              <div class="col-sm-4 col-md-4 col-lg-4"></div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="getBannerList()"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border" style="width:100%">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t('banner.list') }}</b>
              <lte-button
                @click="callback()"
                style="float:right;background-color:white !important; margin-right: 50px"
                type="btn btn-default"
                right_icon="fa fa-plus"
                >{{ $t("user.createnew") }}</lte-button
              >
            </div>
            <!-- <select-option-check
              style="margin-top:-40px;"
              :item="columnsUserguest"
              class="dropdown-trigger"
              data-icon="eye"
            ></select-option-check> -->
          </div>
          <div class="box-body">
            <b-table
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
              :fields="gridColumns"
              :items="gridBannerList"
            >
              <template #head()="data">
                {{ $t(data.label) }}
              </template>
              <template #cell(image)="data">
                <div>
                  <img :src="data.item.image" width="80px" height="50px" />
                </div>
              </template>
              <template #cell(status)="data">
                <div>
                  <span v-if="data.item.status == BannerStatus.ACTIVE" class="btn-label label-success glyphicon glyphicon-ok"></span>
                  <span v-else class="btn-label label-danger glyphicon glyphicon-remove"></span>
                </div>
              </template>
              <template #cell(position)="data">
                <div>
                  {{ $t(getPosition(data.item.position)) }}
                </div>
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <button
                    class="btn btn-primary"
                    style="margin-left: 6px"
                    @click="onEditBanner(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                  <button
                    v-if="data.item.status == BannerStatus.ACTIVE"
                    class="btn btn-warning"
                    style="margin-left: 6px"
                    @click="onActiveBanner(data.item.id, BannerStatus.IN_ACTIVE)"
                  >
                    <i class="glyphicon glyphicon-remove"></i>
                  </button>
                  <button
                    v-else
                    class="btn btn-success"
                    style="margin-left: 6px"
                    @click="onActiveBanner(data.item.id, BannerStatus.ACTIVE)"
                  >
                    <i class="glyphicon glyphicon-ok"></i>
                  </button>
                  <button
                    class="btn btn-danger"
                    style="margin-left: 6px"
                    @click="onDeleteBanner(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
      </row>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
    <div class="modal fade" id="modal-confirm-delete-banner">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t('banner.confirmDeleteBannerTitle') }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              @click="onConfirmDeleteBanner()"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              {{ $t('common.delete_modal.btnYes') }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import { LTEActionTypeEnum } from '@/components/LTEEnum'
// import LTETable from "@/components/LTETable.vue";
import utils from "@/lib/utils";
import Paginator from "@/components/Paginator.vue";
import LTEButton from "@/components/LTEButton.vue";
// import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import BannerStatusEnum from '../../enum/bannerStatusEnum'
import PositionEnum from '../../enum/bannerPositionEnum'
import Loading from "vue-loading-overlay";
export default {
  name: "UserGuestList",
  data() {
    return {
      gridBannerList: [],
      currentPage: 1,
      totalRows: 1,
      entryId: 0,
      user_guest_deleted_id: null,
      user_guest_last_name: "",
      perPage: 50,
      isLoading: false,
      user_guest_name: "",
      isModalVisible: false,
      gridColumns: [
        {
          key: "user_guest.nonumber",
          label: "user_guest.nonumber",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "image",
          label: "banner.image",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "title",
          label: "banner.title",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "status",
          label: "case.status",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "position",
          label: "banner.position",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "dateCreated",
          label: "banner.dateCreated",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "actions",
          label: "mail_form.action",
          class: "text-center",
          tdClass: "stt"
        }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      actions: ["common.modify", "common.delete"],
      // columnsUserguest: {
      //   data_list: [],
      //   itemType: 1,
      //   showLabel: false,
      //   modifyFromPosition: "margin-top:-300px",
      //   cssClassSm1: "col-md-1",
      //   cssClassSm2: "col-sm-1",
      //   showAddNew: false
      // },
      search: {
        full_name: "",
        phone: "",
        identification: ""
      },
      paginatorItem: {
        commit_function: "GET_BANNER_LIST"
      },
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      bannerIdSelected: null,
      BannerStatus: {
        ACTIVE: BannerStatusEnum.ACTIVE,
        IN_ACTIVE: BannerStatusEnum.IN_ACTIVE
      },
      PositionType: {
        TOP: PositionEnum.TOP,
        BOTTOM: PositionEnum.BOTTOM
      },
      positionSelected: null,
      positionList: [
        {
          id: null,
          name: 'banner.selectPosition'
        },
        {
          id: 1,
          name: 'banner.top'
        },
        {
          id: 2,
          name: 'banner.bottom'
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATOR",
      "PAGINATION",
      "GET_ACCOUNT_DATA",
      "GET_BANNER_LIST_DATA"
    ])
  },
  watch: {
    GET_BANNER_LIST_DATA: function () {
      let data = this.GET_BANNER_LIST_DATA;
      this.gridBannerList = []
      for (let i = 0, size = data.length; i < size; i++) {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let object = {
          "user_guest.nonumber": nonumber,
          id: data[i].id,
          'image': data[i].imageUrl,
          "title": data[i].title,
          "status": data[i].status,
          "position": data[i].position,
          'dateCreated': this.formatDate(data[i].dateCreated)
        };
        this.gridBannerList.push(object);
      }
    }
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_BANNER_LIST",
      "DELETE_BANNER",
      "ACTIVE_BANNER"
    ]),
    /**
     * Active banner
     */
    onActiveBanner: function (bannerId, status) {
      let filter = {
        id: bannerId,
        status: status
      }
      this.ACTIVE_BANNER(filter).then(
        function (res) {
          this.getBannerList()
          this.SUCCESS_TOAST()
        }.bind(this)
      )
    },
    /**
     * Get position
     */
    getPosition: function (position) {
      if (this.PositionType.TOP == position) {
        return 'banner.top'
      } else if (this.PositionType.BOTTOM == position) {
        return 'banner.bottom'
      } else {
        return ''
      }
    },
    formatDate(date) {
      return utils.formatSqlDate(date, null, "DD/MM/YYYY");
    },
    /**
     * Edit banner
     */
    onEditBanner: function (id) {
      this.$router.push({
        name: "BannerUpdate",
        params: {
          id: id
        }
      });
    },
    /**
     * Confirm delete banner
     */
    onConfirmDeleteBanner: function () {
      this.DELETE_BANNER({id: this.bannerIdSelected}).then(
        function () {
          this.SUCCESS_TOAST();
          $("#modal-confirm-delete-banner").modal("hide");
          this.getBannerList()
        }.bind(this)
      ).catch(
        function () {
          this.ERROR_TOAST();
        }.bind(this)
      )
    },
    /**
     * Edit banner
     */
    onDeleteBanner: function (id) {
      this.bannerIdSelected = id
      $("#modal-confirm-delete-banner").modal("show");
    },
    callback: function() {
      this.$router.push({
        name: "BannerAdd",
        params: {
          id: 0
        }
      });
    },
    onPagination: function(data) {
      this.GET_BANNER_LIST(data);
    },
    /**
     * Get banner list
     */
    getBannerList: function () {
      const data = {
        params: {
          page: 1,
          position: this.positionSelected
        }
      };
      this.isLoading = true
      this.GET_BANNER_LIST(data).then(
        function () {
          this.isLoading = false
        }.bind(this)
      ).catch(
        function () {
          this.isLoading = false
        }.bind(this)
      )
    }
  },
  mounted() {
    this.getBannerList()
    // this.columnsUserguest.data_list = this.gridColumns;
  },
  components: {
    // "lte-table": LTETable,
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    // "select-option-check": SelectOptionCheck,
    loading: Loading
  }
};
</script>
<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) { 
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/Banner/BannerList.vue